// SECURITY NOTE: Client-side auth guard is UI-only (UX improvement).
// The backend validates the JWT on every request — this guard only
// prevents rendering authenticated pages without a valid session.
import { Navigate, Outlet } from 'react-router-dom'
import { FullPageSpinner } from '@/components/ui/loading-spinner'
import { useAuth } from '@/hooks/use-auth'

export function PrivateRoute() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <FullPageSpinner minHeight='min-h-screen' />
  }

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />
  }

  return <Outlet />
}
